import { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  Checkbox,
  Divider,
  Flex,
  Text,
} from '@chakra-ui/react';
import InfoBanner from '../../../common/InfoBanner';
import { CustomErrorIcon } from '../../../../theme/icons/CustomErrorIcon';

interface DisableEnhancedDesignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  passesCount: number;
}

const DisableEnhancedDesignModal = ({
  isOpen,
  onClose,
  onConfirm,
  passesCount,
}: DisableEnhancedDesignModalProps) => {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (isOpen) setConfirmed(false);
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const passesLabel =
    passesCount === 1
      ? '1 pass will revert to standard view'
      : `${passesCount.toLocaleString('en-GB')} passes will revert to standard view`;

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      closeOnOverlayClick={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        bg="white"
        w="500px"
        maxW="95vw"
        px="32px"
        py="40px"
        borderRadius="10px"
      >
        <ModalCloseButton _hover={{ bg: 'transparent', color: 'grey' }} />
        <ModalBody p={0}>
          <Flex direction="column" gap="24px">
            <Text textStyle="heading4" textAlign="center">
              Disable enhanced pass?
            </Text>
            <Divider borderColor="lightGrey" />
            <Flex direction="column" gap={4}>
              <Text fontSize="18px" color="black">
                Disabling enhanced pass will revert all passes issued from this
                template to the standard design, including passes already in
                your customers&apos; wallets and any new passes issued going forward.
              </Text>
              <Text fontSize="18px" color="black">
                Full-screen artwork and featured actions will be removed
                regardless of the customer&apos;s iOS version.
              </Text>
            </Flex>
            <InfoBanner
              color="#FF0000"
              bg="rgba(255, 0, 0, 0.2)"
              icon={
                <CustomErrorIcon boxSize="22px" color="#FF0000" flexShrink={0} />
              }
              hasLeftBorder={false}
              borderRadius="5px"
              mt={0}
              py="10px"
            >
              <Text fontSize="15px" fontWeight="semibold" color="black">
                {passesLabel}
              </Text>
            </InfoBanner>
            <Checkbox
              variant="primary"
              isChecked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
            >
              <Text fontSize="14px">
                I understand this will revert all existing and future passes to
                the standard design.
              </Text>
            </Checkbox>
            <Flex direction="column" gap={2}>
              <Button
                variant="destructive"
                w="full"
                onClick={handleConfirm}
                isDisabled={!confirmed}
              >
                Disable enhanced pass
              </Button>
              <Button variant="text" w="full" onClick={onClose}>
                Cancel
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DisableEnhancedDesignModal;
